import React from "react";
import './questions.css';
import { useLocation } from 'react-router-dom'; 
import ContextData from './../../context/Data/ContextData'; 

const Questions = () => {   
    const {stateData} = React.useContext(ContextData); 
    const location = useLocation();   

    let titleText = (location.pathname === '/question' ? 'Выбери, чей это Дзен?' : 'Угадай всех персонажей')

    let score = 0;
 
  return ( 
    <div className="questions"> 
        <div className="questions__numbers">
            {stateData.contextQuestionsForUser.map((el, i) => { 
                if(stateData.contextQuestions[el].correct === stateData.contextUserAnswers[i]) score ++;
                if(i+1 === stateData.contextQuestionsForUser.length) stateData.contextScore = score;
                return (
                    <div  className={"questions__number "+(stateData.contextQuestions[el].correct === stateData.contextUserAnswers[i] ? 'correct' : '')} key={'qt'+i}>
                        {(() => {
                            if(stateData.contextUserAnswers[i] < 0){
                                return i+1;
                            } else {
                                return <img src={"assets/img/question"+el+"/ico.svg"} alt="ico" className="questions__ico" />;
                            }
                        })()}
                    </div>
                ); 
            })} 
        </div>
        <div className="questions__title">{titleText}</div>
    </div>
  );
};

export default Questions;
